// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hen_","label":"styles_label__3VMG6"};